import React, { useState, useEffect, useCallback } from "react";

export default function ExportDataTableButton(props) {

  const exportButtonCSVAPICall = () => {
    if (props?.exportButtonCSVAPICall) {
      props.exportButtonCSVAPICall();
    }
  };

  const exportButtonPDFAPICall = () => {
    if (props?.exportButtonPDFAPICall) {
      props.exportButtonPDFAPICall();
    }
  };

  return (
    <div className="dropdown dropdown-inline mr-2 show">
      <button type="button" disabled={props.disabled} className="btn font-weight-bolder dropdown-toggle" style={{ width: "auto", backgroundColor: '#181C32', color: '#fff' }} data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
        <span className="svg-icon svg-icon-md">
          {/* <!--begin::Svg Icon | path:/metronic/theme/html/demo3/dist/assets/media/svg/icons/Design/PenAndRuller.svg--> */}
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <rect x="0" y="0" width="24" height="24"></rect>
              <path d="M3,16 L5,16 C5.55228475,16 6,15.5522847 6,15 C6,14.4477153 5.55228475,14 5,14 L3,14 L3,12 L5,12 C5.55228475,12 6,11.5522847 6,11 C6,10.4477153 5.55228475,10 5,10 L3,10 L3,8 L5,8 C5.55228475,8 6,7.55228475 6,7 C6,6.44771525 5.55228475,6 5,6 L3,6 L3,4 C3,3.44771525 3.44771525,3 4,3 L10,3 C10.5522847,3 11,3.44771525 11,4 L11,19 C11,19.5522847 10.5522847,20 10,20 L4,20 C3.44771525,20 3,19.5522847 3,19 L3,16 Z" fill="#000000" opacity="0.3"></path>
              <path d="M16,3 L19,3 C20.1045695,3 21,3.8954305 21,5 L21,15.2485298 C21,15.7329761 20.8241635,16.200956 20.5051534,16.565539 L17.8762883,19.5699562 C17.6944473,19.7777745 17.378566,19.7988332 17.1707477,19.6169922 C17.1540423,19.602375 17.1383289,19.5866616 17.1237117,19.5699562 L14.4948466,16.565539 C14.1758365,16.200956 14,15.7329761 14,15.2485298 L14,5 C14,3.8954305 14.8954305,3 16,3 Z" fill="#000000"></path>
            </g>
          </svg>
          {/* <!--end::Svg Icon--> */}
        </span> {props.buttonName || "Export"} {props.loading && <span className="ml-3 spinner spinner-white"></span>}</button>
      {/* <!--begin::Dropdown Menu--> */}
      <div className="dropdown-menu dropdown-menu-sm dropdown-menu-right "
        style={{ width: '130px', position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 39px, 0px)', }} x-placement="bottom-end">
        {/* <!--begin::Navigation--> */}
        <ul className="navi flex-column navi-hover py-2">
          {/* <li className="navi-header font-weight-bolder text-uppercase font-size-sm text-primary pb-2">Choose an option:</li> */}

          {
            (props?.typeOfExportDataTable).indexOf('Print') > -1 &&
            <li className="navi-item">
              <a className="navi-link">
                <span className="navi-icon">
                  <i className="la la-print"></i>
                </span>
                <span className="navi-text">Print</span>
              </a>
            </li>
          }
          {
            (props?.typeOfExportDataTable).indexOf('Copy') > -1 &&
            <li className="navi-item">
              <a className="navi-link">
                <span className="navi-icon">
                  <i className="la la-copy"></i>
                </span>
                <span className="navi-text">Copy</span>
              </a>
            </li>
          }
          {
            (props?.typeOfExportDataTable).indexOf('Excel') > -1 &&
            <li className="navi-item">
              <a className="navi-link">
                <span className="navi-icon">
                  <i className="la la-file-excel-o"></i>
                </span>
                <span className="navi-text">Excel</span>
              </a>
            </li>
          }
          {
            (props?.typeOfExportDataTable).indexOf('CSV') > -1 &&
            <li className="navi-item">
              <a className="navi-link" onClick={() => exportButtonCSVAPICall()}>
                <span className="navi-icon">
                  <i className="la la-file-text-o"></i>
                </span>
                <span className="navi-text">CSV</span>
              </a>
            </li>
          }
          {
            (props?.typeOfExportDataTable).indexOf('PDF') > -1 &&
            <li className="navi-item">
              <a className="navi-link" onClick={() => exportButtonPDFAPICall()}>
                <span className="navi-icon">
                  <i className="la la-file-pdf-o"></i>
                </span>
                <span className="navi-text">PDF</span>
              </a>
            </li>
          }
        </ul>
        {/* <!--end::Navigation--> */}
      </div>
      {/* <!--end::Dropdown Menu--> */}
    </div>
  )
}